import { ListItem } from '@/components/controls';
import { parseIfJSON } from '@/utils';
import { types } from '@/utils/constants';
import { mapActions } from '@/utils/mapActions';
import { List, ListSubheader, Stack } from '@mui/material';
import { centerOfMass } from '@turf/turf';
import { Fragment } from 'react';

export function Sidebar({ featureCollections, hoveredFeature, onHover }) {
  const handleMouseOver = (feature, tab) => () => {
    if (feature?.geometry) {
      const centre = centerOfMass(feature);

      onHover({
        longitude: centre.geometry.coordinates[0],
        latitude: centre.geometry.coordinates[1],
        feature: {
          ...feature,
          source: tab,
        },
      });
    } else {
      onHover(null);
    }
  };

  const handleClick = (feature) => () => {
    if (feature) {
      mapActions.panTo(feature);
    }
  };

  return (
    <Stack sx={{ height: 1 }}>
      <List>
        {Object.entries(featureCollections).map(([tab, featureCollection]) => (
          <Fragment key={tab}>
            <ListSubheader>{types[tab].label}</ListSubheader>
            {featureCollection.features.map((feature) => (
              <ListItem
                key={feature.properties[types[tab].idField]}
                tab={tab}
                feature={feature}
                selected={
                  hoveredFeature?.properties[
                    types[hoveredFeature?.source].idField
                  ] === parseIfJSON(feature.properties[types[tab].idField])
                }
                onMouseEnter={handleMouseOver(feature, tab)}
                onMouseLeave={handleMouseOver()}
                onClick={handleClick(feature)}
              />
            ))}
          </Fragment>
        ))}
      </List>
    </Stack>
  );
}
